<template>
  <div class="mainCont p-4 br6 bg-gray100 font14 fw700 gray800">
    Medicine
    <font-awesome-icon size="1x" :icon="['fal', 'arrow-right']" class="ml-auto" :style="{ color: getPrimaryColor() }" />
  </div>
</template>

<script>
export default {
  name: "STreatment",
  props: {},
}
</script>

<style lang="scss" scoped>
.mainCont {
  max-width: 790px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/home/search/STreatment.vue